import React from 'react';
import { 
  FormControl, 
  InputLabel, 
  Select, 
  MenuItem, 
  Typography,
  SelectChangeEvent 
} from '@mui/material';

interface Platform {
  id: string;
  name: string;
}

interface PlatformSelectorProps {
  platforms: Platform[];
  value: string;
  onChange: (e: SelectChangeEvent) => void;
  error?: string;
  required?: boolean;
  disabled?: boolean;
}

const PlatformSelector: React.FC<PlatformSelectorProps> = ({
  platforms,
  value,
  onChange,
  error,
  required = true,
  disabled = false
}) => {
  const label = `Platform${required ? ' *' : ''}`;

  return (
    <FormControl fullWidth margin="normal">
      <InputLabel id="platform-label">{label}</InputLabel>
      <Select
        labelId="platform-label"
        id="platform"
        name="platform"
        value={value}
        label={label}
        onChange={onChange}
        error={!!error}
        disabled={disabled}
      >
        {platforms.map((platform) => (
          <MenuItem key={platform.id} value={platform.name}>
            {platform.name}
          </MenuItem>
        ))}
      </Select>
      {error && (
        <Typography color="error" variant="caption">
          {error}
        </Typography>
      )}
    </FormControl>
  );
};

export default PlatformSelector; 